angular
  .module('contrast.settings.audit', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment',
    'ui.bootstrap'
  ])
  .controller(
    'AuditCtrl',
    function (
      $scope,
      $window,
      $timeout,
      $document,
      SecurityFactory,
      ErrorService,
      SecurityService,
      PromiseService
    ) {
      'ngInject'

      function init() {
        loadLogs($scope.data.numPerLoad, 0)
      }

      var _searchKeywords = ''

      angular.extend($scope, {
        //Data Related Configs/Containers
        data: {
          numPerLoad: 20,
          loadPromise: null,
          busy: false,
          logs: [],
          total: 0
        },
        datepickerModel: {
          startDate: null,
          endDate: null
        }
      })

      //Methods
      angular.extend($scope, {
        loadByScroll: function () {
          if (
            $scope.data.logs.length == $scope.data.total ||
            $scope.data.total == 0
          ) {
            return
          }

          loadLogs($scope.data.numPerLoad, $scope.data.logs.length)
        },
        searchKeywords: function (newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }
          load()
          return _searchKeywords
        },
        handleDateChange: function () {
          load()
        }
      })

      function load() {
        $scope.data.logs = []
        loadLogs($scope.data.numPerLoad, 0)
      }

      function loadLogs(limit, offset) {
        if ($scope.data.loadPromise) {
          PromiseService.cancelPromise($scope.data.loadPromise)
        }

        $scope.data.busy = true
        var data = SecurityService.buildSearchLogForm(
          limit,
          offset,
          Object.assign(
            {},
            { searchKeywords: _searchKeywords },
            $scope.datepickerModel
          )
        )
        $scope.data.loadPromise = SecurityFactory.getLogs(data)

        $scope.data.loadPromise.then(
          function (response) {
            $scope.data.busy = false

            $scope.data.logs = $scope.data.logs.concat(response.data.logs)
            $scope.data.total = response.data.total
            verifyScrollContainerHeight()
          },
          function (response) {
            $scope.data.busy = false

            ErrorService.processError(response)
          }
        )
      }

      function verifyScrollContainerHeight() {
        $timeout(function () {
          var windowHeight = angular.element($window)[0].screen.height
          var scrollContainerHeight = angular
            .element($document)
            .find('#scroll-container')[0].offsetHeight

          if (scrollContainerHeight < windowHeight) {
            $scope.$emit('triggerScrollCheck')
          }
        })
      }

      init()
    }
  )
